/* eslint-disable indent */
import styled from 'styled-components';

const Content = styled.div`
    position: relative;
    padding: ${({theme}) => `0 ${theme.gridGutterWidth}px`};
    align-items: center;
    display: flex;
    font-size: 0.875em;
    width: 100%;
    ${({theme}) =>  theme.currentViewMode === VIEW_MODE.GRID
    ? `
            flex-direction: column;
            height: 100%;
            justify-content: space-around;
            ${ActionGroup} {
                display: inline-flex;
                flex-grow: 0;
                font-size: 2.25rem;
            }
        ` : `
            flex: 1;
            justify-content: space-between;
            overflow: hidden;
            text-overflow: ellipsis;
            &:hover {
                ${ActionGroup} {
                    display:  ${theme.data.cols > 2 ? 'inline-flex' : 'none'};
                }
            }
            ${ActionGroup} {
                display: none;
                font-size: 2.2rem;
            }
        `
}
`;

import { ATTACHMENTS } from 'newJs/config';

const { VIEW_MODE } = ATTACHMENTS;

export const ActionGroup = styled.div`
    align-items: center;
    position: relative;
    ${({ theme }) => {
        if (theme.currentViewMode === VIEW_MODE.GRID) {
            if (theme.data.cols < 3) {
                return `
                    flex-wrap: wrap;
                    justify-content: center;
                `;
            }
        }
    }}
`;

export default Content;
